var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommodityServant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7949 1.04383L1.4318 4.78386C1.17272 4.87186 1 5.13586 1 5.39986V18.6C1 18.886 1.17272 19.128 1.4318 19.216L11.7949 22.956C11.8597 22.978 11.946 23 12.0108 23C12.054 23 12.0756 23 12.1187 23H12.1403C12.1619 23 12.1835 22.978 12.2051 22.978L22.5682 19.238C22.8273 19.15 23 18.886 23 18.622V5.39986V5.37786C23 5.35586 23 5.31186 23 5.28986V5.26786C22.9568 5.04786 22.8057 4.84986 22.5898 4.78386L17.4082 2.91384H17.3867C17.2571 2.86984 17.0844 2.84784 16.9333 2.91384L6.82924 6.54387C6.57017 6.63187 6.39745 6.89587 6.39745 7.15988V9.5799C6.39745 9.9539 6.67812 10.2399 7.04514 10.2399C7.41217 10.2399 7.69284 9.9539 7.69284 9.5799V7.62188L17.1492 4.21185L20.4308 5.39986L11.7949 8.52389C11.5358 8.61189 11.3631 8.85389 11.3631 9.13989C11.3631 9.13989 11.3631 9.13989 11.3631 9.16189V21.438L2.29539 18.138V5.86186L12.2267 2.27584C12.5721 2.14384 12.7448 1.76983 12.6153 1.43983C12.5074 1.08783 12.1403 0.911825 11.7949 1.04383ZM12.6585 9.60189L21.7262 6.32387V18.116L12.6585 21.394V9.60189Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommodityServant);
export default __webpack_public_path__ + "static/media/CommodityServant.636d25f8eefe6b8bb9067461955663ce.svg";
export { ForwardRef as ReactComponent };